import React from 'react';
import { AspectRatio } from './ui/aspect-ratio';

interface VideoPlayerProps {
  videoId: string;
  startTime?: number;
}

export function VideoPlayer({ videoId, startTime = 0 }: VideoPlayerProps) {
  const embedUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0&start=${startTime}&autoplay=1`;
  
  return (
    <AspectRatio ratio={16 / 9} className="bg-muted rounded-lg overflow-hidden">
      <iframe
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="w-full h-full"
      ></iframe>
    </AspectRatio>
  );
}